import React, { useState } from "react";

import { toJS } from "mobx";

import styles from "./team-authorization.module.scss";

import MultiItemSelection from "../MultiSelection/override/MultiSelection";
import { MultiListOverlay } from "sulu-admin-bundle/containers";
import { ResourceRequester } from "sulu-admin-bundle/services";

import { headerColums } from "../../fields/mappers/League";
import { Loader } from "sulu-admin-bundle/components";
import Snackbar from "sulu-admin-bundle/components/Snackbar";

import { useTeamAuthorization } from "./TeamAuthorizationContext";

const Team = ({ teamId, data, name, ageGroup, league, season }) => {
    const [overlayOpen, setOverlayOpen] = useState(false);
    const [selectedItems, setSelectedItems] = useState(data);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [deleteLoadingIndex, setDeleteLoadingIndex] = useState(null);
    const { clubID, locale, optionsParams } = useTeamAuthorization();

    const handleItemAdd = () => {
        setOverlayOpen(true);
    };

    const handleClose = () => {
        setOverlayOpen(false);
    };

    const handleItemRemove = (itemIndex) => {
        const manager = selectedItems[itemIndex];
        setDeleteLoadingIndex(itemIndex);
        ResourceRequester.put(
            "bundlehandler",
            {
                teamId: teamId,
                personId: manager.id,
                action: "teamAuthorizationDelete",
            },
            {
                id: clubID,
                locale: locale,
            }
        )
            .then(() => {
                setSelectedItems((prevItems) => {
                    return prevItems.filter((i) => i.id !== manager.id);
                });
                setDeleteLoadingIndex(null);
            })
            .catch((error) => {
                setError({
                    error: true,
                    message: error.statusText,
                });
                setDeleteLoadingIndex(null);
                console.log(error);
            });
    };

    const handleConfirm = (items) => {
        const managers = toJS(items);
        const ids = items.map((obj) => obj.id);
        setLoading(true);
        setOverlayOpen(false);
        ResourceRequester.put(
            "bundlehandler",
            {
                teamId: teamId,
                personId: ids,
                action: "teamAuthorizationChange",
            },
            {
                id: clubID,
                locale: locale,
            }
        )
            .then(() => {
                setSelectedItems(managers);
                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
                setError({
                    error: true,
                    message: error.statusText,
                });
                console.log(error);
            });
    };

    return (
        <div className={`${styles["team-multiselect"]}`}>
            {error && (
                <Snackbar type="error" message={error.message}></Snackbar>
            )}
            <MultiItemSelection
                disabled={false}
                sortable={false}
                label={null}
                leftButton={{
                    icon: "fa-plus",
                    onClick: handleItemAdd,
                }}
                onItemRemove={handleItemRemove}
                header={() => headerColums(`${name} - ${season} / ${league}`)}
            >
                {loading ? (
                    <Loader />
                ) : (
                    selectedItems.map((item, index) => {
                        return (
                            <MultiItemSelection.Item
                                key={index}
                                id={index}
                                index={index + 1}
                                sortable={true}
                            >
                                {deleteLoadingIndex === index ? (
                                    <div
                                        className={
                                            styles["team-type__item-loader"]
                                        }
                                    >
                                        <Loader size={24} />
                                    </div>
                                ) : (
                                    <div className={styles["team-type__item"]}>
                                        <span
                                            className={
                                                styles[
                                                    "team-type__item-firstname"
                                                ]
                                            }
                                        >
                                            {item?.firstName}
                                        </span>
                                        <span
                                            className={
                                                styles[
                                                    "team-type__item-lastname"
                                                ]
                                            }
                                        >
                                            {item?.lastName}
                                        </span>
                                    </div>
                                )}
                            </MultiItemSelection.Item>
                        );
                    })
                )}
            </MultiItemSelection>
            <MultiListOverlay
                open={overlayOpen}
                onClose={handleClose}
                onConfirm={handleConfirm}
                title="Select team managers"
                resourceKey="contacts"
                preSelectedItems={selectedItems}
                listKey="contact-players"
                allowActivateForDisabledItems={true}
                reloadOnOpen={true}
                adapter="table"
                sortable={false}
                options={optionsParams}
            />
        </div>
    );
};

export default Team;
